import { useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { api } from "../lib/api";
import { Users, GraduationCap } from "lucide-react";

export default function ChooseRole() {
    const { user, setUser } = useAuth();
    const nav = useNavigate();
    const pick = async (role) => {
        const { data } = await api.post("/auth/set-role", { role });
        setUser(data);
        nav("/dashboard");
    };
    return (
        <div className="min-h-screen grain grid place-items-center p-6" data-testid="choose-role-page">
            <div className="card-warm p-8 max-w-md w-full">
                <div className="font-script text-2xl text-[var(--brand-orange)]">welcome, {user?.name?.split(" ")[0]}</div>
                <div className="font-serif text-3xl mb-1">Choose how you'll use VU</div>
                <div className="text-sm text-[var(--text-ink)]/65 mb-5">You can keep this forever, or change later.</div>
                <div className="grid grid-cols-2 gap-3">
                    <button onClick={() => pick("professional")} data-testid="choose-professional"
                            className="p-5 rounded-2xl border-2 border-[rgba(26,19,24,0.12)] hover:border-[var(--brand-purple)] text-left">
                        <Users className="text-[var(--brand-purple)]" />
                        <div className="font-serif text-lg mt-2">Professional</div>
                        <div className="text-xs text-[var(--text-ink)]/65">Clients, contracts, invoicing</div>
                    </button>
                    <button onClick={() => pick("student")} data-testid="choose-student"
                            className="p-5 rounded-2xl border-2 border-[rgba(26,19,24,0.12)] hover:border-[var(--brand-orange)] text-left">
                        <GraduationCap className="text-[var(--brand-orange)]" />
                        <div className="font-serif text-lg mt-2">Student</div>
                        <div className="text-xs text-[var(--text-ink)]/65">Classes, assignments, references</div>
                    </button>
                </div>
            </div>
        </div>
    );
}
